import { useContext } from 'react';
import { GroupEntityTagsUpdateContext } from '../context.js';

export default function useGroupEntityTagsUpdate() {
  return useContext(GroupEntityTagsUpdateContext);
}

export { useGroupEntityTagsUpdate };